export default __webpack_public_path__ + "static/media/cpp.30cd71dc.svg";